<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            class="login-image"
            fluid
            :src="imgUrl"
            alt="Login"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Bem-vindo a IMEDIATO! 👋
          </b-card-title>
          <b-card-text class="mb-2">
            Faça login em sua conta
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                label="Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="seu-email@mail.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label
                    class="label-bold"
                    for="login-password"
                  >Senha</label>
                  <b-link :to="{ name: 'forgot-password', params: { seedEmail: userEmail } }">
                    <small class="label-forgot">Esqueceu sua senha?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Senha"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <div class="invisible-recaptcha">
                <vue-recaptcha
                  ref="recaptcha"
                  size="invisible"
                  :sitekey="recaptchaSiteKey"
                  @verify="onRecaptchaVerify"
                  @expired="onRecaptchaExpired"
                  @error="onRecaptchaError"
                />
              </div>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                class="mt-2"
                block
                @click="validationForm"
              >
                Entrar
              </b-button>
            </b-form>
          </validation-observer>

        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BCardText, BCardTitle, BImg, BForm, BButton,
} from 'bootstrap-vue'
import useSanctum from '@/auth/sanctum/useSanctum'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import navigation from '@/navigation/vertical'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    const isDev = /localhost/.test(window.location.host)
    return {
      status: '',
      userEmail: isDev ? 'admin@globalmed.com' : '',
      password: isDev ? 'Globalmed@321' : '',
      sideImg: require('@/assets/images/pages/login-imediato-logo.svg'),
      recaptchaToken: null,
      pendingLogin: false,
      recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-imediato-logo.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    executeRecaptcha() {
      this.pendingLogin = true
      this.$refs.recaptcha.execute()
    },
    onRecaptchaVerify(token) {
      this.recaptchaToken = token
      if (this.pendingLogin) {
        this.pendingLogin = false
        this.submitLogin()
      }
    },
    onRecaptchaExpired() {
      this.recaptchaToken = null
      this.pendingLogin = false
    },
    onRecaptchaError() {
      this.recaptchaToken = null
      this.pendingLogin = false
      this.$refs.loginValidation.setErrors({
        password: 'Não foi possível validar a segurança. Tente novamente.',
      })
    },
    resetRecaptcha() {
      this.recaptchaToken = null
      this.pendingLogin = false
      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.reset()
      }
    },
    async validationForm() {
      const success = await this.$refs.loginValidation.validate()

      if (!success) return

      if (this.recaptchaToken) {
        await this.submitLogin()
        return
      }

      this.executeRecaptcha()
    },
    async submitLogin() {
      try {
        const response = await useSanctum.login({
          institution: '44650069000136', // CNPJ Imediato
          email: this.userEmail,
          password: this.password,
          recaptcha: this.recaptchaToken,
        })

        const userData = response.data
        // @TODO
        // userData.user_access_type = {
        //   institution_id: '4a69c3e8-71c6-45f1-970f-e46f78d39868',
        //   slugname: 'comercial',
        //   user_id: '449e3de3-e11d-4a7e-9647-1f16f487335f',
        // }
        userData.access_type = userData.user_access_type ? userData.user_access_type.slugname : 'operacional'
        userData.role = userData.roles.length ? userData.roles[0].name : 'institution'

        const reportResources = navigation
          .filter(n => n.title === 'Relatórios' || n.title === 'Relatórios ')
          .reduce((acc, menu) => {
            acc.push(...menu.children)
            return acc
          }, [])
          .map(n => n.resource)

        const reportAbilities = reportResources.map(subject => ({ action: 'read', subject }))
        const headersAbilities = [
          { action: 'Financial', resource: 'Financial' },
          { action: 'Integrations', resource: 'Integrations' },
          { action: 'Admin', resource: 'Admin' },
        ]
        const ability = {
          operacional: [
            { action: 'read', subject: 'all' },
            ...headersAbilities,
          ],
          gestor: [
            { action: 'manage', subject: 'all' },
          ],
          comercial: [
            { action: 'read', subject: 'Home' },
            { action: 'read', subject: 'Institution' },
            { action: 'read', subject: 'Physician' },
            { action: 'read', subject: 'ReportPhysicians' },
            { action: 'read', subject: 'ReportPhysicianFirstAdvance' },
            { action: 'read', subject: 'ReportPhysicianActivate' },
            { action: 'manage', subject: 'Faq' },
            { action: 'manage', subject: 'Partner' },
            { action: 'Financial', resource: 'Financial' },
            { action: 'Admin', resource: 'Admin' },
            ...reportAbilities,
          ],
          financeiro: [
            { action: 'read', subject: 'all' },
            { action: 'manage', subject: 'ReportSyncErrors' },
            ...headersAbilities,
          ],
        }
        userData.abilities = ability[userData.access_type]

        localStorage.setItem('userData', JSON.stringify(userData))
        this.$ability.update(userData.abilities)

        this.$router.replace(getHomeRouteForLoggedInUser(userData.access_type))
          .then(() => {
            //
          })
      } catch (error) {
        const errors = (error.response && error.response.status === 422 && error.response.data.errors) || {}
        const errorCode = error.response && error.response.data && error.response.data.error_code
        if (errorCode === 1657582529) {
          this.$refs.loginValidation.setErrors({
            email: 'Usuário inativo',
          })
          return
        }
        if (Object.keys(errors).some(key => key === 'recaptcha')) {
          this.resetRecaptcha()
          this.$refs.loginValidation.setErrors({
            password: 'Dispositivo não passou no teste de segurança. Tente novamente.',
          })
        } else {
          this.resetRecaptcha()
          this.$refs.loginValidation.setErrors({
            email: 'Email ou Senha incorretos',
          })
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.label-forgot {
  color: #e85d2a;
}
.login-image {
  max-width: 500px;
}
</style>
